import * as Language from './language-keys';

import * as ApiConstants from './api';

export const LanguageKeys: { [key: string]: string } = Language;
export const Api = ApiConstants;
